import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PreviewImageComponent } from 'src/modules/shared/components/preview-image/preview-image.component';
import { ImageRequest} from 'src/modules/shared/models/Flow';
import { TCCPConstantValues } from 'src/modules/shared/models/tccp-constants';
import { TCCPCommonService } from 'src/modules/shared/services/tccp-common.service';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-badge-management',
  templateUrl: './badge-management.component.html',
  styleUrls: ['./badge-management.component.scss']
})
export class BadgeManagementComponent implements OnInit {

  public selectedApp = this.adminService.selectedApplication;
  public badgeList : any [] =[];
  public alerts: any[] = [];
  public badge: string;
  public filename = '';
  public imageUrl = `${environment.baseURL}content/${this.selectedApp}/images/`;
  public fileExtension = 'png';  
  private googleBadge = new BehaviorSubject<string>(
    `${this.imageUrl}badges-google.${this.fileExtension}`
  );

  private appleBadge = new BehaviorSubject<string>(
    `${this.imageUrl}badges-google.${this.fileExtension}`
  );
  
  currentGoogleBadge = this.googleBadge.asObservable();
  currentAppleBadge = this.appleBadge.asObservable();

  constructor(private dialog: MatDialog, private adminService: AdminService, private commonService:TCCPCommonService) { }

  ngOnInit() {
    this.loadBadgeList();
  }

  loadBadgeList(){
    this.badgeList = this.commonService.getBadgeNames(this.selectedApp);
  }

  updatePhoto(badgeName: any){
      if(badgeName === 'google'){
        this.googleBadge.next(`${this.imageUrl}badges-google.${this.fileExtension}`)
      }else{
        this.appleBadge.next(`${this.imageUrl}badges-apple.${this.fileExtension}`)
      }
  }

  openS3ImageDialog() {
    const dialogRef = this.dialog.open(PreviewImageComponent, {
      height: '98%',
      width: '100vw',
      maxWidth: '95vw',
      panelClass: 'full-screen-modal',
      data: { type: 'step' }
    });
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  onFileChange(files: FileList, type: string, badgeName: any) {
    this.alerts = [];
    this.badge = badgeName.name;
    const imageExtensionTypes = ['image/png'];
    const iconExtensionTypes = ['image/png'];
    let isValid = false;
    if (files[0].type.indexOf('image') !== -1) {
      if (imageExtensionTypes.indexOf(files[0].type) === -1) {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.BADGE_PNG_FORMAT_MESSAGE);
        isValid = false;
      } else {
        isValid = true;
      }
    } else if (type === '') {
      if (imageExtensionTypes.indexOf(files[0].type) === -1 ) {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.BADGE_PNG_FORMAT_MESSAGE);
        isValid = false;
      } else {
        isValid = true;
      }
    } else if (type === 'unknown') {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.BADGE_PNG_FORMAT_MESSAGE);
      isValid = false;
    } 
    
    if(isValid){
    if (files[0].name !== '') {
      const ext = files[0].name.split('.').pop();
      this.fileExtension = ext;
      this.filename = files[0].name.replace('.' + ext, new Date().getTime() + '.' + ext);
      if (isValid) {
        const fileRequestBody = new ImageRequest();
        fileRequestBody.source = this.adminService.selectedApplication;
        fileRequestBody.contentType = files[0].type;
        fileRequestBody.fileName = `badges-${this.badge}.png`;
        fileRequestBody.contentBase64 = null;
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {          
            this.adminService.uploadImage(fileRequestBody).subscribe((response: any) => {
              if (response) {
                this.uploadtoS3(files[0], response.url, files[0].type, response.path);
                this.getLinkPic(this.badge);
              }
            });
        };
      }
    }
  }
  }

  getLinkPic(badge:any){
    if(badge==='google'){
      this.currentGoogleBadge.subscribe((img)=>{
        this.setImage(badge, img);
      })
    }else if(badge.name==='apple'){
      this.currentAppleBadge.subscribe((img)=>{
        this.setImage(badge, img);
      })
    }
  }

  uploadtoS3(fileRequest: File, response: string, type: string, path) {
    this.adminService.uploadtoS3(fileRequest, response, type).subscribe(() => {
    });
  }

  setImage(badgeName, img){
   const result = this.badgeList.find((item, index)=> {
      if(item.name === badgeName){
        this.badgeList[index].iconLink = `${img}?${(new Date()).getTime()}`;
      }
    });
    this.commonService.setBadgeNames(this.badgeList);
    if(result){
      return;
    }
  }
}
